import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
   faAlignJustify,
   faBars,
   faCheck,
   faCheckSquare,
   faClock,
   faComment,
   faEdit,
   faHome,
   faKey,
   faList,
   faMoneyCheck,
   faPaperclip,
   faSearch,
   faSignInAlt,
   faSignOutAlt,
   faTh,
   faUser,
   faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

library.add(
   faAlignJustify,
   faBars,
   faCheck,
   faCheckSquare,
   faClock,
   faComment,
   faEdit,
   faHome,
   faKey,
   faList,
   faMoneyCheck,
   faPaperclip,
   faSearch,
   faSignInAlt,
   faSignOutAlt,
   faTh,
   faUser,
   faUserPlus,
);

export { FontAwesomeIcon };
